<template>
  <div>
    <nav-breadcrumb :menu="[{label :'提前还款'}]"/>

    <el-row>
      <el-col>
        <panel label="">
          <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">

                <el-col :span="24">
                    <el-form-item label="贷款编号："  style="width: 90%">
                        {{dataForm.fi__contractNo}}
                    </el-form-item>
                </el-col>
              <el-col :span="24">
                <el-form-item label="客户姓名："  style="width: 60%">
                  {{dataForm.fi__customerName}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="提前还款模式：" prop="t__inFull" :rules="{required: true, message: '不能为空'}" style="width: 60%">
                  <el-radio-group v-model="dataForm.t__inFull" :disabled="true" class = "button_radio">
                    <el-radio-button label="Y">全款</el-radio-button>
                    <el-radio-button label="N">部分</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="提前还款日期：" prop="t__repayDate" :rules="{required: true, message: '日期不能为空'}"  label-width="150px">
                  <el-date-picker
                    v-model="dataForm.t__repayDate"
                    value-format="yyyy-MM-dd 00:00:00"
                    format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期" :disabled="true">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="提前还款金额：">
                  <el-input v-model="dataForm.t__totalAmount"  :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </panel>
  <!--      <div class="cb tr of" style="margin-bottom:8px">
          <el-button class="tab_close" @click="showPanelChange()" v-show="(dataForm.currents[0]||{}).curr__sequenceNo&&showPanel">收起<i class="el-icon-caret-top
   el-icon&#45;&#45;right"></i></el-button>
          <el-button class="tab_open" @click="showPanelChange()" v-show="(dataForm.currents[0]||{}).curr__sequenceNo&&!showPanel">展开<i class="el-icon-caret-bottom el-icon&#45;&#45;right"></i></el-button>
        </div>-->
        <el-row :gutter="20" style="margin-bottom: 0px;" v-show="(dataForm.currents[0]||{}).curr__sequenceNo">
          <el-col :span="12"><div class="Htitle-text color-danger">截止提前还款日前该客户要应先偿还以下还款：</div></el-col>
        </el-row>
        <panel :title="'第'+item.curr__sequenceNo+'期（最后还款日：'+ item.curr__expectedRepayDate+'）'" border v-for="(item, idx) in dataForm.currents" :key="idx" v-show="item.curr__sequenceNo&&showPanel">
          <!-- <div v-if="item.needAmount == 0">本期已还清</div>-->

          <form-build :form-data="item" :form-columns="repayInfoColumns"></form-build>

          <!--<div class="tr" style="padding-right:15px">本期还清还需：{{item.needAmount}}</div>-->
        </panel>
    <!--    <panel :title="'第'+(dataForm.currents[0]||{}).curr__sequenceNo+'期（最后还款日：'+ (dataForm.currents[0]||{}).curr__expectedRepayDate+'）'" border  v-show="(dataForm.currents[0]||{}).curr__sequenceNo&&!showPanel">
          <div v-if="(dataForm.currents[0]||{}).needAmount == 0">本期已还清</div>
          <div v-else>本期还清还需：{{(dataForm.currents[0]||{}).needAmount}}</div>
          <form-build :form-data="(dataForm.currents[0]||{})" :form-columns="repayInfoColumns"></form-build>
        </panel>-->
        <panel :title="'银行转账'" border>
          <form-build :form-data="dataForm" :form-columns="bankColumns"  labelWidth="250px"></form-build>
        </panel>

        <panel v-show="this.dataForm.t__currentApplied=='Y'" :title="'计息时段('+this.dataForm.t__currentFrDate+'-'+this.dataForm.t__currentToDate+')'" border>
          <form-build :form-data="dataForm" :form-columns="interestColumns"></form-build>
        </panel>
        <panel v-show="this.dataForm.t__inFull=='N'">
          <span class="fwb">实际提前还款金额</span> <span v-html="showformula1"></span>=<span class="fwb color-danger">{{dataForm.t__repayAmountInAdvance}}</span>
        </panel>
        <panel v-show="this.dataForm.t__inFull=='Y'">
          <span class="fwb">提前还款可用金额</span>{{showformula2}}=<span class="fwb color-danger">{{showformula2__equal}}</span><br/><br/>


          <span class="fwb">提前还款金额</span>{{showformula3}}=<span class="fwb color-danger">{{showformula3__equal}}</span><br/><br/>

            <span class="fwb">应还本金</span>=<span class="fwb color-danger">{{expectedPrincipalAmounts}}</span><br/><br/>
            <span class="fwb">应还利息</span>=<span class="fwb color-danger">{{expectedInterestAmounts}}</span><br/><br/>
            <span class="fwb">应付罚息</span>=<span class="fwb color-danger">{{appliedOverdueFines}}</span><br/><br/>
            <span class="fwb">应付复利</span>=<span class="fwb color-danger">{{appliedCompoundInterests}}</span><br/><br/>

          <span class="fwb">余额</span>={{showformula4}} = <span class="fwb color-danger">{{dataForm.t__excessAmount}}</span><br/><br/>
        </panel>
        <panel v-show="this.dataForm.t__inFull=='N'">
          <el-row :gutter="20" style="margin-bottom: 0px;">
            <el-col :span="12"><div class="Htitle-text">提前还款试算表</div></el-col>
            <el-col :span="12">
              <div class="tr">
                <el-button class="tab_close" @click="showPanelListChange()" v-show="showPanelList">收起<i class="el-icon-caret-top
   el-icon--right"></i></el-button>
                <el-button class="tab_open" @click="showPanelListChange()" v-show="!showPanelList">展开<i class="el-icon-caret-bottom el-icon--right"></i></el-button>
              </div>
            </el-col>
          </el-row>
          <data-table v-show="showPanelList"
                      :table-data="tableData"
                      :columns="columns"
                      :page.sync="page"
                      :pageSize.sync="pageSize"
                      :filters.sync="filters"
                      :actions="actions"
                      :is-pagination-show="false"
                      :row-class-name="rowClassName"
          />
          <data-table v-show="!showPanelList"
                      :table-data="tableDataOne"
                      :columns="columns"
                      :page.sync="page"
                      :pageSize.sync="pageSize"
                      :filters.sync="filters"
                      :actions="actions"
                      :is-pagination-show="false"
                      :row-class-name="rowClassName"
          />
        </panel>
        <!--<panel  v-show="dataForm.t__inFull=='Y'">
          <form-build :form-data="dataForm" :form-columns="dataColumns2" ></form-build>
        </panel>-->
        <panel  v-show="this.dataForm.t__inFull=='Y'&&dataForm.t__excessAmount>0" border>
          <form-build :form-data="dataForm" :form-columns="dataColumns2" ></form-build>
        </panel>
        <panel>备注：{{dataForm.t__remarks}}</panel>
        <Panel>审核意见：<el-input type="textarea" v-model="dataForm.a__remarks" ></el-input></Panel>
        <el-button type="primary" @click="updateApprove('Approved')">审核通过</el-button>
        <el-button @click="updateApprove('Rejected')">否决</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import Status2CN from "../../filters/Status2CN";
  import Panel from "../../components/Panel";
  import {formatMoney} from "../../filters/CommonFilters";
  export default {
    name: "TransferRepaymentEdit",
    components: {Panel},
    data(){

      return {
          expectedPrincipalAmounts:0,
          expectedInterestAmounts:0,
          appliedOverdueFines:0,
          appliedCompoundInterests:0,
        bankColumns:[

          {
            label: '本次转账总额',
            field: 't__totalAmount',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            }
          },
          {
            label: '提前还款实际使用金额',
            field: 't__repayAmountInAdvance',
            formatter: (r,v) => {
              return formatMoney(Number(v+parseFloat(this.freeAmount))||0)
            }
          },
        ],
        interestColumns:[
          {
            label: '剩余本金',
            field: 't__currentPrincipalAmount',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            }
          },
          {
            label: '应还利息',
            field: 't__currentInterestAmount',
            formatter: (r,v) => {
              if(this.dataForm.t__inFull=='N')
                return formatMoney(Number(v)||0)+"（下期偿还）"
              else
                return formatMoney(Number(v)||0)
            }
          },
          {
            label: '计息天数',
            field: 't__currentDays',
            formatter: (r,v) => {
              return (Number(v)||0)
            },
            span:24
          },
        ],
        showformula1:'',
        showformula2:'',
        showformula3:'',
        showformula4:'',
        showformula2__equal:'',
        showformula3__equal:'',



        showPanel:true,
        showPanelList:true,
        tableDataOne: {
          data:[],
          count:0,
        },
        applicationId:this.$route.query['applicationId']||'',
        tableDataList:{
          data:[],
          count:0,
        },
        dataColumns2:[
          {
            label: '余额处理',
            field: 't__excessAmountOption',
            formatter: (r,v) => {
              return Status2CN(v)

            },
            span:12
          },
        ],
        disabled:false,
        inFull:true,
        tableDataMatching:{
          count: 0,
          data: []
        },
        columnsMatching:[
          {
            type: 'index'
          },
          {
            label: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            label: '客户姓名',
            field: 'c__customerName'
          },
          {
            label: '贷款开始时间',
            field: 'fi__startDate',
            formatter: function (r,c,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
              else
                return ''
            }
          },
          {
            label: '贷款结束时间',
            field: 'fi__endDate',
            formatter: (r,c,v) => {
              return moment(v).format('YYYY-MM-DD')
            },
          },
          {
            label: '贷款金额',
            field: 'fi__totalAmount',
            formatter: (r,c,v) => {
              return formatMoney(v)
            },
          },
          {
            label: '操作',
            opts:[
              {
                label: '选择',
                class: 'el-icon-finished',
                clickHandler: (index, row)=> {
                  this.Selected(row)
                }
              },
            ]
          }
        ],

        rowClassName: function ({row, idx}) {
          if(row.plan__repaymentStatus=='Settled'){
            return 'bg_color_yhq'
          }else{
            if(row.plan__revisedPrincipalAmount==null){
              return 'bg_color_dclnone'
            }else{
              return 'bg_color_dcl'
            }
          }
        },
        dataForm:{
          currents:[]
        },
        dataFormRules: {},
        tableData: {
          data:[],
          count:0,
        },
        dialogVisible: false,
        page: 1,
        pageSize: 20,
        actions: [
        ],
        filters: {
          labelWidth: '150px',
          form: {

          },
          columns: [

          ],
          onSubmit:()=>{
          }
        },
        columns:[
          {
            label: '期数',
            field: 'plan__sequenceNo'
          },
          {
            label: '还款日期',
            field: 'plan__repayDate'
          },
          {
            label: '本金',
            field: 'plan__principalAmount'
          },
          {
            label: '利息',
            field: 'plan__interestAmount'
          },
          {
            label: '还款状态',
            field: 'plan__repaymentStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '试算本金',
            field: 'plan__revisedPrincipalAmount',
            formatter: function (r,c,v) {
              if(r.plan__repaymentStatus=='Settled')
                return '---'
              else
                return formatMoney(v)
            }
          },
          {
            label: '试算利息',
            field: 'plan__revisedInterestAmount',
            formatter: function (r,c,v) {
              if(r.plan__repaymentStatus=='Settled')
                return '---'
              else
                return formatMoney(v)
            }
          },
        ],
        currentsColumns:[
          {
            label: '还款日期',
            field: 'curr__expectedRepayDate'
          },
          {
            label: '应收复利',
            field: 'curr__expectedCompoundInterest',
            formatter: (r,c,v) => {
              if(r.curr__waiveCompoundInterest=='Y')
                return (0).toFixed(2)
              else
                return formatMoney(Number(v)||0)
            }
          },
          {
            label: '应收罚息',
            field: 'curr__expectedOverdueFine',
            formatter: (r,c,v) => {
              if(r.curr__waiveOverdueFine=='Y')
                return (0).toFixed(2)
              else
                return formatMoney(Number(v)||0)
            }
          },
          {
            label: '减免金额',
            field: 'deductionAmount',
            formatter: (r,c,v) => {
              let deductionAmount = 0
              if(r.curr__waiveOverdueFine=='Y')
                deductionAmount = deductionAmount + parseFloat(r.curr__expectedOverdueFine - r.curr__appliedOverdueFine)
              if(r.curr__waiveCompoundInterest=='Y')
                deductionAmount = deductionAmount + parseFloat(r.curr__expectedCompoundInterest - r.curr__appliedCompoundInterest)
              return formatMoney(deductionAmount)

            }
          },
        ],
        repayInfoColumns: [
          {
            label: '应还款日',
            field: 'curr__expectedRepayDate',
          },
          {
            label: '上期余额',
            field: 'curr__exBalanceAmount',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            }
          },
          {
            label: '应还本金',
            field: 'curr__expectedPrincipalAmount',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            }
          },
          {
            label: '实收复利',
            field: 'curr__appliedCompoundInterest',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            }
          },
          {
            label: '应还利息',
            field: 'curr__expectedInterestAmount',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            }
          },
          {
            label: '实收罚息',
            field: 'curr__appliedOverdueFine',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            }
          },
          {
            label: '逾期天数',
            field: 'curr__overdueDays'
          },
          {
            label: '实收利息',
            field: 'curr__appliedInterestAmount',
            component: (r,v) => {
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}} <span v-if="v < r.curr__expectedInterestAmount">( {{ Number((v- r.curr__expectedInterestAmount).toFixed(2))}})</span></div>`,
                data() {
                  return {
                    r,
                    v
                  }
                }
              }
            }
          },
          {
            label: '应收复利',
            field: 'curr__expectedCompoundInterest',
            component: (r,v)=> {
              let disabled2 = this.disabled2
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox :disabled="true" type="radio"  v-model="r.curr__waiveCompoundInterest" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                data() {
                  return {
                    r,
                    v,
                    disabled2
                  }
                }
              }
            }
          },
          {
            label: '实收本金',
            field: 'curr__appliedPrincipalAmount',
            component: (r,v) => {
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}} <span v-if="v < r.curr__expectedPrincipalAmount">( {{ Number((v- r.curr__expectedPrincipalAmount).toFixed(2))}})</span></div>`,
                data() {
                  return {
                    r,
                    v
                  }
                }
              }
            }
          },
          {
            label: '应还罚息',
            field: 'curr__expectedOverdueFine',
            component: (r,v)=> {
              let disabled2 = this.disabled2
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox type="radio" :disabled="true"  v-model="r.curr__waiveOverdueFine" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                data() {
                  return {
                    r,
                    v,
                    disabled2
                  }
                }
              }
            }
          },
          {
            label: '本期余额',
            field: 'curr__excessAmount',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            }
          },
          {
            label: '应收合计',
            field: 'expectedTotalAmount',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            },
            span: 24
          },
        ],
        repayPlanList: [],
      }
    },
    mounted() {
      this.getData()
    },
    computed: {
      watchChecked() {
        return this.dataForm.currents.map(item=>({
          curr__waiveCompoundInterest: item.curr__waiveCompoundInterest,
          curr__waiveOverdueFine: item.curr__waiveOverdueFine
        }))
      },
      freeAmount() {
        return (this.dataForm.currents.reduce( (total, item)=> {
          total += item.curr__waiveCompoundInterest == 'Y' ? item.curr__expectedCompoundInterest : 0
          total += item.curr__waiveOverdueFine == 'Y'? item.curr__expectedOverdueFine : 0

          return total;
        }, 0)).toFixed(2)
      }
    },
    watch: {

      watchChecked: function () {
        this.calculateDetail()
      }
    },
    created() {
      this.calculateDetail()
    },
    methods:{
      showPanelChange:function(){
        this.showPanel = !this.showPanel
      },
      showPanelListChange:function(){
        this.showPanelList = !this.showPanelList
      },
      getData: function () {
        xhr.getApproveRepaymentInAdvance(
          {
            't.applicationId': this.$route.query['applicationId']
          },
          res=> {
            try {
              this.dataForm = res.data.data
              this.tableData.data = res.data.data.detail||[]
              this.tableData.count =  this.tableData.data.length
              this.tableDataOne.data.push(res.data.data.detail[0]||[])
              this.tableDataOne.count = 1
              this.showformula1 = formatMoney(this.dataForm.t__totalAmount)
              if(this.dataForm.t__exBalanceAmount>0)
                this.showformula1 = this.showformula1 +' + <span title="上期余额" style="text-decoration: underline;cursor:pointer">'+formatMoney(this.dataForm.t__exBalanceAmount)+'</span>'
              let appliedRepayAmount = 0
              this.dataForm.currents.forEach(item=>{
                if(item.curr__appliedRepayAmount>0&&item.curr__appliedRepayAmount){
                  this.showformula1 = this.showformula1+'-'+item.curr__appliedRepayAmount
                  appliedRepayAmount = appliedRepayAmount + item.curr__appliedRepayAmount*100
                }

              })
              this.showformula2 = formatMoney(this.dataForm.t__totalAmount)
              if(appliedRepayAmount>0){
                this.showformula2 = this.showformula2 +'-'+formatMoney(appliedRepayAmount/100)
              }
              this.showformula2__equal = formatMoney((this.dataForm.t__totalAmount*100 - appliedRepayAmount)/100)
              this.showformula3 =formatMoney( this.dataForm.t__currentPrincipalAmount)
              if(this.dataForm.t__currentInterestAmount>0)
                this.showformula3 = this.showformula3 +'+'+formatMoney(this.dataForm.t__currentInterestAmount)
              this.showformula3__equal = formatMoney(this.dataForm.t__currentPrincipalAmount+this.dataForm.t__currentInterestAmount)
              this.showformula4 = formatMoney((this.dataForm.t__totalAmount*100 - appliedRepayAmount)/100) +'-'+formatMoney(this.dataForm.t__currentPrincipalAmount+this.dataForm.t__currentInterestAmount)
              if(this.showformula3.indexOf('+')>-1||this.showformula3.indexOf('-')>-1){
                this.showformula3 = '='+this.showformula3
              }else{
                this.showformula3 = ''
              }
              if(this.showformula2.indexOf('+')>-1||this.showformula2.indexOf('-')>-1){
                this.showformula2 = '='+this.showformula2
              }else{
                this.showformula2 = ''
              }
              if(this.showformula1.indexOf('+')>-1||this.showformula1.indexOf('-')>-1){
                this.showformula1 = '='+this.showformula1
              }else{
                this.showformula1 = ''
              }

            }catch(e){

            }
          })

      },
      calculateDetail() {
        console.log('k')
        let balanceAmount = Number(this.dataForm.t__totalAmount)||0
          this.expectedPrincipalAmounts = 0
          this.expectedInterestAmounts = 0
          this.appliedOverdueFines = 0
          this.appliedCompoundInterests = 0
        this.dataForm.currents.forEach((item,idx)=> {
          idx > 0 && (item.curr__exBalanceAmount = this.dataForm.currents[idx-1].curr__excessAmount)

          item.curr__appliedCompoundInterest = item.curr__waiveCompoundInterest == 'Y' ? 0 : ( balanceAmount > item.curr__expectedCompoundInterest ? item.curr__expectedCompoundInterest :  balanceAmount  )
          balanceAmount = Number((balanceAmount - item.curr__appliedCompoundInterest).toFixed(2))

          item.curr__appliedOverdueFine = item.curr__waiveOverdueFine == 'Y'? 0 : ( balanceAmount > item.curr__expectedOverdueFine ? item.curr__expectedOverdueFine :  balanceAmount )
          balanceAmount = Number((balanceAmount - item.curr__appliedOverdueFine).toFixed(2))

          item.curr__appliedInterestAmount = balanceAmount > item.curr__expectedInterestAmount ? item.curr__expectedInterestAmount : balanceAmount
          balanceAmount = Number((balanceAmount - item.curr__appliedInterestAmount).toFixed(2))

          item.curr__appliedPrincipalAmount = balanceAmount > item.curr__expectedPrincipalAmount ? item.curr__expectedPrincipalAmount : balanceAmount
          balanceAmount = Number((balanceAmount - item.curr__appliedPrincipalAmount).toFixed(2))

          item.expectedTotalAmount = Number(( (item.curr__waiveCompoundInterest== 'Y' ? 0 : item.curr__expectedCompoundInterest) +  (item.curr__waiveOverdueFine== 'Y' ? 0 : item.curr__expectedOverdueFine) + item.curr__expectedInterestAmount + item.curr__expectedPrincipalAmount).toFixed(2))

          item.needAmount = Number((item.expectedTotalAmount - item.curr__appliedCompoundInterest -item.curr__appliedOverdueFine-item.curr__appliedInterestAmount-item.curr__appliedPrincipalAmount).toFixed(2))

          item.curr__excessAmount = balanceAmount

            this.expectedPrincipalAmounts += Number(item.curr__expectedPrincipalAmount)
            this.expectedInterestAmounts += Number(item.curr__expectedInterestAmount)
            this.appliedOverdueFines += Number(item.curr__appliedOverdueFine)
            this.appliedCompoundInterests += Number(item.curr__appliedCompoundInterest)
        })

          this.expectedPrincipalAmounts += Number(this.dataForm.t__currentPrincipalAmount)
          this.expectedInterestAmounts +=  Number(this.dataForm.t__currentInterestAmount)
          this.expectedPrincipalAmounts =this.expectedPrincipalAmounts.toFixed(2)
          this.expectedInterestAmounts =this.expectedInterestAmounts.toFixed(2)
          this.appliedOverdueFines =this.appliedOverdueFines.toFixed(2)
          this.appliedCompoundInterests =this.appliedCompoundInterests.toFixed(2)
      },
      updateApprove:function (status) {
        const form ={}
        console.log(this.applicationId)
        form.t__applicationId = this.applicationId
        form.a__applicationId = this.applicationId
        form.a__approvingStatus=status
        form.a__remarks = this.dataForm.a__remarks
        form.t__checked = true
        xhr.updateApproveRepaymentInAdvance(
          form,
          res=> {
            try{
              if(res.data.status == 'success') {
                this.$router.push({
                  path: 'List',
                })
              }else{

                this.$message.error(res.data.msgs[0].text)
              }

            }catch (e) {

              this.$message.error(error.msgs[0].text)

            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApplyingRepaymentInAdvanceApprove.vue